/* =====================================================================
   NayHogar · motor "nh-funciona" (NHF) · "Así funciona" de cada producto
   Lo carga snippets/nh-funciona.liquid (desde sections/nh-experiencia.liquid) SOLO en los productos que tienen
   escena propia: assets/fn-<handle>.js (+ .css opcional), registrados en snippets/fn-escenas.liquid.
   Cada escena se registra con  NHF.escena('<handle>', function (E) { ... })  y arma su experiencia con:
     - E.lienzo({w,h,...})   escenario con capas hechas de la FOTO REAL (coordenadas = px de la foto, p. ej. 1600x1600)
       S.img / S.div / S.canvas / S.luz / S.toque / S.camara / S.mapear / S.punto ...
     - E.paso / E.seg / E.boton / E.interruptor / E.deslizador / E.lectura / E.perilla / E.arrastrable  (controles)
     - E.fx.* (vapor, gotas, giro con desenfoque, llenado, destello) · E.animar / E.esperar / E.bucle · E.sonido
   Regla de oro: el producto SIEMPRE es la foto real; los efectos solo muestran lo que el producto hace según su ficha.
   Manual completo: tiendas/nayhogar/RECETA_FUNCIONA.md
   ===================================================================== */
(function () {
  if (window.NHF) return;
  const mm = q => { try { return window.matchMedia(q).matches; } catch (e) { return false; } };
  const reduce = mm('(prefers-reduced-motion: reduce)');
  const fino = mm('(pointer: fine)');
  const escenas = {};
  const NHF = window.NHF = { escenas, reduce, fino, version: '1.0' };

  /* ---------------- utilidades ---------------- */
  const esc = s => String(s == null ? '' : s).replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const clamp = (x, a, b) => Math.min(b, Math.max(a, x));
  const lerp = (a, b, k) => a + (b - a) * k;
  const suave = k => k < .5 ? 4 * k * k * k : 1 - Math.pow(-2 * k + 2, 3) / 2;
  const salida = k => 1 - Math.pow(1 - k, 3);
  const resorte = k => 1 - Math.cos(k * Math.PI * 4.5) * Math.exp(-k * 6);
  function el(tag, cls, html, attrs) {
    const e = document.createElement(tag);
    if (cls) e.className = cls;
    if (html != null) e.innerHTML = html;
    if (attrs) Object.keys(attrs).forEach(k => { if (attrs[k] != null) e.setAttribute(k, attrs[k]); });
    return e;
  }
  function animar(dur, cb, fin, curva) {
    const f = curva || suave;
    if (reduce || dur <= 0) { cb(1, 1); if (fin) fin(); return () => {}; }
    const t0 = performance.now(); let parar = false;
    const paso = t => { if (parar) return; const k = clamp((t - t0) / dur, 0, 1); cb(f(k), k); if (k < 1) requestAnimationFrame(paso); else if (fin) fin(); };
    requestAnimationFrame(paso);
    return () => { parar = true; };
  }
  const animarP = (dur, cb, curva) => new Promise(r => animar(dur, cb, r, curva));
  const esperar = ms => new Promise(r => setTimeout(r, reduce ? Math.min(ms, 120) : ms));
  function precargar(src) {
    return new Promise(r => {
      if (!src) return r(null);
      const i = new Image(); i.decoding = 'async'; i.crossOrigin = 'anonymous';
      i.onload = () => { (i.decode ? i.decode().catch(() => {}) : Promise.resolve()).then(() => r(i)); };
      i.onerror = () => r(null);
      i.src = src;
    });
  }
  function vibrar(ms) { if (navigator.vibrate) { try { navigator.vibrate(ms || 10); } catch (e) {} } }

  /* ---------- homografía: lleva un cuadrilátero a otro (para bisagras y piezas con perspectiva) ----------
     q = [[x,y] x4] en orden: arriba-izq, arriba-der, abajo-der, abajo-izq */
  function resolver(A, b) { // eliminación gaussiana 8x8
    const n = b.length;
    for (let i = 0; i < n; i++) {
      let m = i; for (let r = i + 1; r < n; r++) if (Math.abs(A[r][i]) > Math.abs(A[m][i])) m = r;
      [A[i], A[m]] = [A[m], A[i]]; [b[i], b[m]] = [b[m], b[i]];
      const p = A[i][i] || 1e-12;
      for (let r = i + 1; r < n; r++) { const f = A[r][i] / p; for (let c = i; c < n; c++) A[r][c] -= f * A[i][c]; b[r] -= f * b[i]; }
    }
    const x = new Array(n).fill(0);
    for (let i = n - 1; i >= 0; i--) { let s = b[i]; for (let c = i + 1; c < n; c++) s -= A[i][c] * x[c]; x[i] = s / (A[i][i] || 1e-12); }
    return x;
  }
  function homografia(src, dst) {
    const A = [], b = [];
    for (let i = 0; i < 4; i++) {
      const [x, y] = src[i], [u, v] = dst[i];
      A.push([x, y, 1, 0, 0, 0, -u * x, -u * y]); b.push(u);
      A.push([0, 0, 0, x, y, 1, -v * x, -v * y]); b.push(v);
    }
    const h = resolver(A, b);
    return [h[0], h[1], h[2], h[3], h[4], h[5], h[6], h[7], 1];
  }
  function matriz3d(h) { // h fila por fila -> matrix3d (columna por columna)
    return 'matrix3d(' + [h[0], h[3], 0, h[6], h[1], h[4], 0, h[7], 0, 0, 1, 0, h[2], h[5], 0, h[8]].map(v => +v.toFixed(9)).join(',') + ')';
  }
  const lerpQuad = (a, b, k) => a.map((p, i) => [lerp(p[0], b[i][0], k), lerp(p[1], b[i][1], k)]);
  // interpola un cuadrilátero entre cuadros clave {angulos:[...], quads:[...]} para un valor t
  function quadEn(clave, t) {
    const a = clave.angulos, q = clave.quads;
    if (t <= a[0]) return q[0];
    for (let i = 1; i < a.length; i++) if (t <= a[i]) return lerpQuad(q[i - 1], q[i], (t - a[i - 1]) / (a[i] - a[i - 1]));
    return q[q.length - 1];
  }

  /* ---------------- sonido (opcional, apagado por defecto) ---------------- */
  const Sonido = {
    activo: false, ctx: null,
    _c() { if (!this.ctx) { const C = window.AudioContext || window.webkitAudioContext; if (!C) return null; this.ctx = new C(); } if (this.ctx.state === 'suspended') this.ctx.resume(); return this.ctx; },
    tono(f, dur, vol, tipo) {
      if (!this.activo) return; const c = this._c(); if (!c) return;
      const o = c.createOscillator(), g = c.createGain(); o.type = tipo || 'sine'; o.frequency.value = f || 1800;
      const t = c.currentTime, d = dur || 0.07, v = vol == null ? 0.045 : vol;
      g.gain.setValueAtTime(0, t); g.gain.linearRampToValueAtTime(v, t + 0.006); g.gain.exponentialRampToValueAtTime(0.0001, t + d);
      o.connect(g); g.connect(c.destination); o.start(t); o.stop(t + d + 0.02);
    },
    bip(f) { this.tono(f || 2100, 0.075, 0.04); },
    clic() { this.tono(320, 0.035, 0.05, 'triangle'); },
    ruido(dur, vol, filtro) { // soplido suave (aire, agua)
      if (!this.activo) return null; const c = this._c(); if (!c) return null;
      const n = Math.floor(c.sampleRate * 1.2), buf = c.createBuffer(1, n, c.sampleRate), d = buf.getChannelData(0);
      for (let i = 0; i < n; i++) d[i] = Math.random() * 2 - 1;
      const s = c.createBufferSource(); s.buffer = buf; s.loop = true;
      const f = c.createBiquadFilter(); f.type = 'lowpass'; f.frequency.value = filtro || 900;
      const g = c.createGain(); g.gain.value = 0; s.connect(f); f.connect(g); g.connect(c.destination); s.start();
      g.gain.linearRampToValueAtTime(vol == null ? 0.03 : vol, c.currentTime + 0.3);
      const fin = () => { try { g.gain.linearRampToValueAtTime(0, c.currentTime + 0.25); s.stop(c.currentTime + 0.3); } catch (e) {} };
      if (dur) setTimeout(fin, dur);
      return { parar: fin, volumen(v) { try { g.gain.linearRampToValueAtTime(v, c.currentTime + 0.15); } catch (e) {} }, filtro(v) { f.frequency.value = v; } };
    }
  };
  NHF.sonido = Sonido;

  /* ---------------- iconos de los controles ---------------- */
  const IC = {
    repetir: '<path d="M4 12a8 8 0 1 0 2.3-5.6M4 4v4.5h4.5"/>',
    sonido: '<path d="M4 9.5v5h3.5L12 18V6L7.5 9.5H4z"/><path d="M15.5 9a4 4 0 0 1 0 6M18 6.5a7.5 7.5 0 0 1 0 11"/>',
    mudo: '<path d="M4 9.5v5h3.5L12 18V6L7.5 9.5H4z"/><path d="M16 9.5l5 5M21 9.5l-5 5"/>',
    mano: '<path d="M9 11V5.5a1.5 1.5 0 0 1 3 0V10m0-1.5a1.5 1.5 0 0 1 3 0V11m0-1a1.5 1.5 0 0 1 3 0v4.5a6 6 0 0 1-6 6h-.6a6 6 0 0 1-4.9-2.6L4 15.3a1.5 1.5 0 0 1 2.4-1.8L9 15"/>',
    toca: '<circle cx="12" cy="12" r="3"/><circle cx="12" cy="12" r="8" opacity=".45"/>',
    flechas: '<path d="M8 7l-5 5 5 5M16 7l5 5-5 5M3 12h18"/>',
    gira: '<path d="M20 12a8 8 0 1 1-3-6.2"/><path d="M20 4v4.5h-4.5"/>',
    lupa: '<circle cx="11" cy="11" r="6.5"/><path d="M16 16l4.5 4.5"/>',
    menos: '<path d="M5 12h14"/>'
  };
  const svg = (n, s) => '<svg viewBox="0 0 24 24" width="' + (s || 18) + '" height="' + (s || 18) + '" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + (IC[n] || '') + '</svg>';
  NHF.icono = svg;

  /* ======================================================================
     ESCENARIO: lienzo con coordenadas en px de la foto real; se escala solo al ancho disponible.
     ====================================================================== */
  function crearLienzo(E, o) {
    o = o || {};
    const W = o.w || 1600, H = o.h || 1600;
    const marco = el('div', 'nhf-escena' + (o.clase ? ' ' + o.clase : ''));
    const cam = el('div', 'nhf-cam');
    const lz = el('div', 'nhf-lienzo');
    lz.style.width = W + 'px'; lz.style.height = H + 'px';
    if (o.fondo) marco.style.background = o.fondo;
    cam.appendChild(lz); marco.appendChild(cam);
    // la "envoltura" lleva el escenario y encima el HUD (pista, sonido, repetir): en el celular la pista sale debajo
    // del escenario para no tapar lo que se toca
    const env = el('div', 'nhf-envoltura');
    const hud = el('div', 'nhf-hud'); env.append(marco, hud);
    E.zonaEscena.appendChild(env);

    const S = { el: marco, envoltura: env, cam, lienzo: lz, hud, w: W, h: H, k: 1 };
    // vista = parte del lienzo que se ve; el marco toma su proporción (en celular puede ser otra)
    let vistaBase = o.vista || [0, 0, W, H];
    let vistaMovil = o.vistaMovil || null;
    let vista = null, transicion = 0;
    const esMovil = () => window.innerWidth < 760;
    function base() { return (esMovil() && vistaMovil) ? vistaMovil : vistaBase; }
    function ajustar(v) { // misma proporción del marco y dentro del lienzo
      const b = base(), ar = b[2] / b[3];
      let [x, y, w, h] = v;
      if (w / h > ar) { const nh = w / ar; y -= (nh - h) / 2; h = nh; } else { const nw = h * ar; x -= (nw - w) / 2; w = nw; }
      if (!o.libre) {
        if (w > W) { w = W; h = w / ar; } if (h > H) { h = H; w = h * ar; }
        x = clamp(x, 0, W - w); y = clamp(y, 0, H - h);
      }
      return [x, y, w, h];
    }
    function pintar() {
      const b = base();
      marco.style.aspectRatio = (b[2] / b[3]).toFixed(5);
      const ancho = marco.clientWidth || 1;
      const v = vista || b;
      S.k = ancho / v[2];
      cam.style.transitionDuration = (reduce ? 0 : transicion) + 'ms';
      cam.style.transform = 'translate3d(' + (-v[0] * S.k).toFixed(2) + 'px,' + (-v[1] * S.k).toFixed(2) + 'px,0) scale(' + S.k.toFixed(5) + ')';
      marco.style.setProperty('--nhf-k', S.k.toFixed(5));
    }
    S.camara = function (v, dur) { // v = [x,y,w,h] en px del lienzo, o null para volver a la vista completa
      transicion = dur == null ? 1100 : dur;
      vista = v ? ajustar(v) : null;
      marco.classList.toggle('is-cerca', !!v);
      pintar();
      return esperar(reduce ? 0 : transicion);
    };
    S.vista = (v, vm) => { vistaBase = v || vistaBase; if (vm !== undefined) vistaMovil = vm; pintar(); };
    if ('ResizeObserver' in window) new ResizeObserver(() => { const t = transicion; transicion = 0; pintar(); transicion = t; }).observe(marco);
    else window.addEventListener('resize', () => { transicion = 0; pintar(); });
    requestAnimationFrame(pintar);

    function caja(e, b, z) {
      e.style.left = b[0] + 'px'; e.style.top = b[1] + 'px';
      if (b[2] != null) e.style.width = b[2] + 'px';
      if (b[3] != null) e.style.height = b[3] + 'px';
      if (z != null) e.style.zIndex = z;
    }
    function poner(e, op) {
      const p = op && op.en ? op.en : lz; // "en": dentro de un grupo (sus hijos usan coordenadas del lienzo igual)
      if (op && op.en && op.en._caja) { const c = op.en._caja; e.style.left = (parseFloat(e.style.left) - c[0]) + 'px'; e.style.top = (parseFloat(e.style.top) - c[1]) + 'px'; }
      if (op && op.antes) p.insertBefore(e, op.antes); else p.appendChild(e);
      return e;
    }
    function origen(e, b, op) { if (op && op.pivote) e.style.transformOrigin = (op.pivote[0] - b[0]) + 'px ' + (op.pivote[1] - b[1]) + 'px'; }
    // capa de imagen: archivo del tema (fn-...) o URL; caja [x,y,w,h] en px del lienzo
    S.img = function (src, b, op) {
      op = op || {};
      b = b || [0, 0, W, H];
      const i = el('img', 'nhf-capa' + (op.clase ? ' ' + op.clase : ''), null, { alt: op.alt || '', draggable: 'false', decoding: 'async' });
      if (!op.alt) i.setAttribute('aria-hidden', 'true');
      i.src = E.archivo(src);
      caja(i, b, op.z);
      if (op.mezcla) i.style.mixBlendMode = op.mezcla;
      if (op.opacidad != null) i.style.opacity = op.opacidad;
      origen(i, b, op);
      i._caja = b.slice();
      return poner(i, op);
    };
    S.div = function (b, op) {
      op = op || {};
      const d = el('div', 'nhf-capa' + (op.clase ? ' ' + op.clase : ''), op.html || null);
      caja(d, b, op.z); origen(d, b, op);
      if (op.mezcla) d.style.mixBlendMode = op.mezcla;
      if (op.opacidad != null) d.style.opacity = op.opacidad;
      d._caja = b.slice();
      return poner(d, op);
    };
    S.grupo = (b, op) => S.div(b, Object.assign({ clase: 'nhf-grupo' }, op || {}));
    // lienzo de dibujo para efectos (vapor, agua, giro...): se dibuja con coordenadas del lienzo
    S.canvas = function (b, op) {
      op = op || {};
      b = b || [0, 0, W, H];
      const res = op.res || Math.min(1, (window.devicePixelRatio || 1) * 0.5 + 0.25);
      const c = el('canvas', 'nhf-capa nhf-fx' + (op.clase ? ' ' + op.clase : ''));
      c.width = Math.max(1, Math.round(b[2] * res)); c.height = Math.max(1, Math.round(b[3] * res));
      caja(c, b, op.z);
      if (op.mezcla) c.style.mixBlendMode = op.mezcla;
      const ctx = c.getContext('2d');
      const reset = () => ctx.setTransform(res, 0, 0, res, -b[0] * res, -b[1] * res);
      reset();
      poner(c, op);
      return { el: c, ctx, caja: b, res, limpiar() { ctx.setTransform(1, 0, 0, 1, 0, 0); ctx.clearRect(0, 0, c.width, c.height); reset(); }, reset };
    };
    // luz que sale de un punto real de la foto (led, bombillo, pantalla): degradado radial en modo "screen"
    S.luz = function (x, y, r, op) {
      op = op || {};
      const d = el('span', 'nhf-luz' + (op.clase ? ' ' + op.clase : ''));
      const ry = op.ry || r;
      caja(d, [x - r, y - ry, r * 2, ry * 2], op.z == null ? 30 : op.z);
      if (op.mezcla) d.style.mixBlendMode = op.mezcla;
      const L = { el: d, k: 0, color: op.color || '#FFD27A' };
      L.color = op.color || '#FFD27A';
      L.pintar = () => {
        const c = L.color, n = op.nucleo == null ? 0.18 : op.nucleo;
        d.style.background = 'radial-gradient(closest-side,' + (op.centro || '#fff') + ' 0,' + c + ' ' + (n * 100) + '%,' + hexA(c, .55) + ' ' + (n * 100 + 22) + '%,' + hexA(c, 0) + ' 100%)';
      };
      L.set = (k, color) => { if (color && color !== L.color) { L.color = color; L.pintar(); } L.k = k; d.style.opacity = clamp(k, 0, 1); };
      L.pintar(); L.set(op.k || 0);
      poner(d, op);
      return L;
    };
    // zona tocable sobre la foto (tecla, botón, perilla). caja [x,y,w,h]; redonda con op.redonda
    S.toque = function (b, op) {
      op = op || {};
      const t = el('button', 'nhf-toque' + (op.redonda ? ' is-redonda' : '') + (op.clase ? ' ' + op.clase : ''), op.html || '', { type: 'button', 'aria-label': op.etiqueta || '' });
      caja(t, b, op.z == null ? 50 : op.z);
      if (op.alTocar) t.addEventListener('click', e => { e.preventDefault(); marco.classList.add('is-tocado'); op.alTocar(e); });
      return poner(t, op);
    };
    // coordenadas del lienzo desde un evento del puntero
    S.punto = function (e) {
      const r = lz.getBoundingClientRect();
      return { x: (e.clientX - r.left) / r.width * W, y: (e.clientY - r.top) / r.height * H };
    };
    // pone un elemento (con su caja local 0..w,0..h o un cuadrilátero propio "src") sobre el cuadrilátero "dst" del lienzo
    S.mapear = function (e, dst, src) {
      const b = e._caja || [parseFloat(e.style.left) || 0, parseFloat(e.style.top) || 0, e.offsetWidth, e.offsetHeight];
      const s = src || [[b[0], b[1]], [b[0] + b[2], b[1]], [b[0] + b[2], b[1] + b[3]], [b[0], b[1] + b[3]]];
      const sl = s.map(p => [p[0] - b[0], p[1] - b[1]]), dl = dst.map(p => [p[0] - b[0], p[1] - b[1]]);
      e.style.transformOrigin = '0 0';
      e.style.transform = matriz3d(homografia(sl, dl));
    };
    // pista flotante ("Toca una tecla")
    S.pista = function (texto, icono) {
      let p = hud.querySelector('.nhf-pista');
      if (!texto) { if (p) p.classList.add('is-off'); return; }
      if (!p) { p = el('span', 'nhf-pista', null, { 'aria-hidden': 'true' }); hud.appendChild(p); }
      p.innerHTML = svg(icono || 'mano', 16) + '<span>' + esc(texto) + '</span>';
      p.classList.remove('is-off');
    };
    // marca de texto pequeña sobre la escena (p. ej. "Demostración")
    S.marca = function (texto) {
      let m = hud.querySelector('.nhf-marca');
      if (!texto) { if (m) m.remove(); return; }
      if (!m) { m = el('span', 'nhf-marca'); hud.appendChild(m); }
      m.textContent = texto;
    };
    S.cargando = si => marco.classList.toggle('is-cargando', !!si);
    return S;
  }
  function hexA(c, a) { // '#RRGGBB' + alfa -> rgba()
    if (!c || c[0] !== '#') return c;
    const h = c.length === 4 ? c.replace(/#(.)(.)(.)/, '#$1$1$2$2$3$3') : c;
    const n = parseInt(h.slice(1, 7), 16);
    return 'rgba(' + (n >> 16 & 255) + ',' + (n >> 8 & 255) + ',' + (n & 255) + ',' + a + ')';
  }

  /* ======================================================================
     EFECTOS dibujados livianos (fotográficos y sutiles). Se dibujan en un S.canvas.
     ====================================================================== */
  const fx = {
    /* Partículas: vapor, gotas, burbujas, polvo, chispas. Devuelve {emitir(n), paso(dt), vivas}
       op: { origen:[x,y] o caja [x,y,w,h], tipo:'vapor'|'gotas'|'burbujas'|'polvo'|'chispa', color, vel:[vx,vy], dispersion, vida, tam, gravedad } */
    particulas(lz, op) {
      const P = []; const o = Object.assign({ tipo: 'vapor', vida: 2.2, tam: 40, dispersion: 20, vel: [0, -60], gravedad: 0, color: '255,255,255', alfa: 0.18 }, op || {});
      function nueva() {
        const c = o.origen || [0, 0];
        const x = c.length === 4 ? c[0] + Math.random() * c[2] : c[0] + (Math.random() - .5) * o.dispersion;
        const y = c.length === 4 ? c[1] + Math.random() * c[3] : c[1] + (Math.random() - .5) * o.dispersion * .3;
        return { x, y, vx: o.vel[0] + (Math.random() - .5) * o.dispersion * .6, vy: o.vel[1] * (0.7 + Math.random() * .6), t: 0, vida: o.vida * (0.7 + Math.random() * .6), s: o.tam * (0.6 + Math.random() * .8), r: Math.random() * 6.28, w: (Math.random() - .5) * 1.2 };
      }
      return {
        P,
        emitir(n) { for (let i = 0; i < n; i++) P.push(nueva()); },
        paso(dt, dibujar) {
          const ctx = lz.ctx;
          for (let i = P.length - 1; i >= 0; i--) {
            const p = P[i]; p.t += dt; if (p.t > p.vida) { P.splice(i, 1); continue; }
            p.vy += o.gravedad * dt; p.x += p.vx * dt + Math.sin(p.t * 2 + p.r) * (o.tipo === 'vapor' ? 12 : 0) * dt; p.y += p.vy * dt;
            if (dibujar === false) continue;
            const k = p.t / p.vida;
            if (o.tipo === 'vapor' || o.tipo === 'polvo') {
              const a = o.alfa * Math.sin(Math.PI * Math.min(1, k * 1.15)) * (o.tipo === 'polvo' ? 0.8 : 1);
              const s = p.s * (0.6 + k * 1.6);
              const g = ctx.createRadialGradient(p.x, p.y, 0, p.x, p.y, s);
              g.addColorStop(0, 'rgba(' + o.color + ',' + a + ')'); g.addColorStop(1, 'rgba(' + o.color + ',0)');
              ctx.fillStyle = g; ctx.beginPath(); ctx.arc(p.x, p.y, s, 0, 6.2832); ctx.fill();
            } else if (o.tipo === 'gotas') {
              const a = o.alfa * (1 - k * .5), len = Math.max(p.s * .25, Math.hypot(p.vx, p.vy) * 0.03);
              const ang = Math.atan2(p.vy, p.vx);
              ctx.save(); ctx.translate(p.x, p.y); ctx.rotate(ang);
              const g = ctx.createLinearGradient(-len, 0, len, 0);
              g.addColorStop(0, 'rgba(' + o.color + ',0)'); g.addColorStop(.7, 'rgba(' + o.color + ',' + a + ')'); g.addColorStop(1, 'rgba(255,255,255,' + Math.min(1, a * 1.6) + ')');
              ctx.fillStyle = g; ctx.beginPath(); ctx.ellipse(0, 0, len, p.s * 0.09 + 1.2, 0, 0, 6.2832); ctx.fill(); ctx.restore();
            } else if (o.tipo === 'burbujas') {
              const a = o.alfa * Math.sin(Math.PI * k), s = p.s * .25;
              ctx.strokeStyle = 'rgba(' + o.color + ',' + a + ')'; ctx.lineWidth = Math.max(1, s * .12);
              ctx.beginPath(); ctx.arc(p.x, p.y, s, 0, 6.2832); ctx.stroke();
            } else { // chispa / brillo
              const a = o.alfa * (1 - k), s = p.s * (1 - k * .6);
              const g = ctx.createRadialGradient(p.x, p.y, 0, p.x, p.y, s);
              g.addColorStop(0, 'rgba(255,255,255,' + a + ')'); g.addColorStop(.3, 'rgba(' + o.color + ',' + a * .6 + ')'); g.addColorStop(1, 'rgba(' + o.color + ',0)');
              ctx.fillStyle = g; ctx.beginPath(); ctx.arc(p.x, p.y, s, 0, 6.2832); ctx.fill();
            }
          }
        }
      };
    },
    /* Giro de una pieza real (aspas, plato, cepillo) visto en perspectiva: la elipse del giro se "endereza", se gira
       y se vuelve a inclinar (transformación afín), con desenfoque de movimiento real (varias copias en el arco).
       op: { img (Image ya cargada), caja [x,y,w,h] donde va la imagen en el lienzo, centro [cx,cy], inclinacion (rad,
       eje mayor de la elipse), aplaste (b/a: 1 = de frente), angulo (rad), barrido (rad del arco de desenfoque), muestras } */
    giro(lz, op) {
      const ctx = lz.ctx, [cx, cy] = op.centro, t = op.inclinacion || 0, k = op.aplaste || 1, img = op.img, b = op.caja;
      const n = Math.max(1, op.muestras || 1), barrido = op.barrido || 0;
      ctx.save();
      for (let i = 0; i < n; i++) {
        const a = op.angulo - barrido * (n === 1 ? 0 : i / (n - 1));
        ctx.globalAlpha = (op.alfa == null ? 1 : op.alfa) * (n === 1 ? 1 : (1.6 / n) * (1 - 0.55 * i / n));
        ctx.save();
        ctx.translate(cx, cy); ctx.rotate(t); ctx.scale(1, k); ctx.rotate(a); ctx.scale(1, 1 / k); ctx.rotate(-t); ctx.translate(-cx, -cy);
        ctx.drawImage(img, b[0], b[1], b[2], b[3]);
        ctx.restore();
      }
      ctx.restore();
    },
    /* Llenado de un recipiente (jarra, tanque, vaso): sube el nivel dentro de un polígono real del recipiente.
       op: { poligono [[x,y]...], fondo (y del fondo), tope (y lleno), nivel 0..1, color 'r,g,b', alfa, ola (0..1), t } */
    llenado(lz, op) {
      const ctx = lz.ctx, pol = op.poligono, nivel = clamp(op.nivel, 0, 1);
      if (nivel <= 0) return;
      const y = lerp(op.fondo, op.tope, nivel), xs = pol.map(p => p[0]), x0 = Math.min(...xs), x1 = Math.max(...xs);
      ctx.save();
      ctx.beginPath(); pol.forEach((p, i) => i ? ctx.lineTo(p[0], p[1]) : ctx.moveTo(p[0], p[1])); ctx.closePath(); ctx.clip();
      const ola = (op.ola || 0) * 6, t = op.t || 0;
      ctx.beginPath(); ctx.moveTo(x0 - 4, op.fondo + 4);
      for (let x = x0 - 4; x <= x1 + 4; x += 6) ctx.lineTo(x, y + Math.sin(x * 0.045 + t * 5) * ola);
      ctx.lineTo(x1 + 4, op.fondo + 4); ctx.closePath();
      const g = ctx.createLinearGradient(0, y, 0, op.fondo);
      g.addColorStop(0, 'rgba(' + op.color + ',' + (op.alfa || .8) * 0.85 + ')'); g.addColorStop(1, 'rgba(' + op.color + ',' + (op.alfa || .8) + ')');
      ctx.fillStyle = g; ctx.fill();
      // menisco: línea de luz en la superficie
      ctx.strokeStyle = 'rgba(255,255,255,' + (op.brillo == null ? .28 : op.brillo) + ')'; ctx.lineWidth = 2.5;
      ctx.beginPath(); for (let x = x0; x <= x1; x += 6) { const yy = y + Math.sin(x * 0.045 + t * 5) * ola; x === x0 ? ctx.moveTo(x, yy) : ctx.lineTo(x, yy); } ctx.stroke();
      ctx.restore();
    },
    /* Chorro de líquido (café, agua, jabón) entre dos puntos, con brillo lateral */
    chorro(lz, op) {
      const ctx = lz.ctx, [x, y0] = op.desde, y1 = op.hasta, w = op.ancho || 6, t = op.t || 0;
      ctx.save();
      const g = ctx.createLinearGradient(x - w, 0, x + w, 0);
      g.addColorStop(0, 'rgba(' + op.color + ',0)'); g.addColorStop(.3, 'rgba(' + op.color + ',' + (op.alfa || .85) + ')');
      g.addColorStop(.55, 'rgba(255,255,255,' + (op.brillo || .25) + ')'); g.addColorStop(.75, 'rgba(' + op.color + ',' + (op.alfa || .85) + ')'); g.addColorStop(1, 'rgba(' + op.color + ',0)');
      ctx.fillStyle = g;
      ctx.beginPath(); ctx.moveTo(x - w * .5, y0);
      for (let y = y0; y <= y1; y += 8) ctx.lineTo(x - w * .5 + Math.sin(y * .08 + t * 14) * .8, y);
      for (let y = y1; y >= y0; y -= 8) ctx.lineTo(x + w * .5 + Math.sin(y * .08 + t * 14 + 1) * .8, y);
      ctx.closePath(); ctx.fill();
      ctx.restore();
    },
    /* Barrido de brillo sobre una superficie real (vidrio, panel solar, acero): franja de luz que pasa */
    destello(lz, op) {
      const ctx = lz.ctx, b = op.caja, k = op.k; // k 0..1 posición del barrido
      ctx.save();
      if (op.poligono) { ctx.beginPath(); op.poligono.forEach((p, i) => i ? ctx.lineTo(p[0], p[1]) : ctx.moveTo(p[0], p[1])); ctx.closePath(); ctx.clip(); }
      const x = lerp(b[0] - b[2] * .4, b[0] + b[2] * 1.4, k), w = b[2] * (op.ancho || .22);
      const g = ctx.createLinearGradient(x - w, b[1], x + w, b[1] + b[3] * .35);
      g.addColorStop(0, 'rgba(255,255,255,0)'); g.addColorStop(.5, 'rgba(255,255,255,' + (op.alfa || .35) + ')'); g.addColorStop(1, 'rgba(255,255,255,0)');
      ctx.fillStyle = g; ctx.fillRect(b[0], b[1], b[2], b[3]);
      ctx.restore();
    },
    /* Brillo cálido (resistencias, brasas, luz interior) dentro de un polígono real */
    resplandor(lz, op) {
      const ctx = lz.ctx, b = op.caja;
      ctx.save();
      if (op.poligono) { ctx.beginPath(); op.poligono.forEach((p, i) => i ? ctx.lineTo(p[0], p[1]) : ctx.moveTo(p[0], p[1])); ctx.closePath(); ctx.clip(); }
      const cx = op.centro ? op.centro[0] : b[0] + b[2] / 2, cy = op.centro ? op.centro[1] : b[1] + b[3] / 2;
      const r = op.radio || Math.max(b[2], b[3]) * .7;
      const g = ctx.createRadialGradient(cx, cy, 0, cx, cy, r);
      g.addColorStop(0, 'rgba(' + op.color + ',' + op.k + ')'); g.addColorStop(.55, 'rgba(' + op.color + ',' + op.k * .45 + ')'); g.addColorStop(1, 'rgba(' + op.color + ',0)');
      ctx.fillStyle = g; ctx.fillRect(b[0], b[1], b[2], b[3]);
      ctx.restore();
    }
  };
  /* Luces reales (WebGL): la foto ENCENDIDA y la misma APAGADA (mismos píxeles sin el brillo de los leds) + un mapa
     de leds (R = fase de cada led, G = posición a lo largo de la tira) + el halo (brillo difuso). Cada modo prende y
     apaga los leds reales desde su posición real. op: { caja, on, off, mapa, halo (imágenes ya cargadas), res }.
     Devuelve { modo(n 0..7), noche(0..1), encendidas(bool), brillo(0..1), pintar(t), activo } o null sin WebGL. */
  fx.luces = function (S, op) {
    const b = op.caja, res = op.res || Math.min(1, (window.devicePixelRatio || 1) * 0.5);
    const c = document.createElement('canvas'); c.className = 'nhf-capa nhf-fx';
    c.width = Math.round(b[2] * res); c.height = Math.round(b[3] * res);
    c.style.left = b[0] + 'px'; c.style.top = b[1] + 'px'; c.style.width = b[2] + 'px'; c.style.height = b[3] + 'px'; c.style.zIndex = op.z || 2;
    const gl = c.getContext('webgl', { premultipliedAlpha: false, antialias: false, preserveDrawingBuffer: false });
    if (!gl) return null;
    S.lienzo.appendChild(c);
    const vs = 'attribute vec2 p;varying vec2 v;void main(){v=vec2(p.x*.5+.5,.5-p.y*.5);gl_Position=vec4(p,0.,1.);}';
    const fs = 'precision mediump float;uniform sampler2D a,o,m,h;uniform float T,M,N,E,B;varying vec2 v;' +
      'float rn(float x){return fract(sin(x*91.345)*47453.5453);}' +
      'void main(){vec3 on=texture2D(a,v).rgb,of=texture2D(o,v).rgb,ha=texture2D(h,v).rgb;vec3 mp=texture2D(m,v).rgb;float ph=mp.r,xp=mp.g;float k=1.;' +
      'if(M>.5&&M<1.5)k=.5+.5*sin(6.2832*(T*.55-xp*1.6));' +
      'else if(M>1.5&&M<2.5)k=step(.5,fract(xp*4.-T*.9));' +
      'else if(M>2.5&&M<3.5)k=.12+.88*(.5+.5*sin(T*1.7));' +
      'else if(M>3.5&&M<4.5)k=step(.5,fract(T*1.6+(ph>.5?.5:0.)));' +
      'else if(M>4.5&&M<5.5)k=.15+.85*pow(.5+.5*sin(T*5.+ph*60.),3.);' +
      'else if(M>5.5&&M<6.5){float q=fract(T*.35);k=q<.5?q*2.:(1.-q)*2.;}' +
      'else if(M>6.5)k=rn(floor(T*4.)+ph*100.)>.45?1.:.1;' +
      'k=clamp(k,0.,1.)*E*B;vec3 bg=of*(1.-.8*N);vec3 lz=max(on-of,0.);' +
      'gl_FragColor=vec4(bg+lz*k*(1.+.25*N)+ha*k*N*.9,1.);}';
    const sh = (t, src) => { const x = gl.createShader(t); gl.shaderSource(x, src); gl.compileShader(x); return x; };
    const pr = gl.createProgram(); gl.attachShader(pr, sh(gl.VERTEX_SHADER, vs)); gl.attachShader(pr, sh(gl.FRAGMENT_SHADER, fs)); gl.linkProgram(pr);
    if (!gl.getProgramParameter(pr, gl.LINK_STATUS)) { c.remove(); return null; }
    gl.useProgram(pr);
    const buf = gl.createBuffer(); gl.bindBuffer(gl.ARRAY_BUFFER, buf);
    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-1, -1, 1, -1, -1, 1, 1, 1]), gl.STATIC_DRAW);
    const loc = gl.getAttribLocation(pr, 'p'); gl.enableVertexAttribArray(loc); gl.vertexAttribPointer(loc, 2, gl.FLOAT, false, 0, 0);
    const tex = (img, u, i) => {
      const t = gl.createTexture(); gl.activeTexture(gl.TEXTURE0 + i); gl.bindTexture(gl.TEXTURE_2D, t);
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR); gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE); gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
      gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGB, gl.RGB, gl.UNSIGNED_BYTE, img); gl.uniform1i(gl.getUniformLocation(pr, u), i); return t;
    };
    const L = { el: c, m: 0, n: 0, e: 0, b: 1, activo: true };
    L.texturas = (on, off, mapa, halo) => { tex(on, 'a', 0); tex(off, 'o', 1); tex(mapa, 'm', 2); tex(halo, 'h', 3); };
    L.texturas(op.on, op.off, op.mapa, op.halo);
    const U = n => gl.getUniformLocation(pr, n);
    const uT = U('T'), uM = U('M'), uN = U('N'), uE = U('E'), uB = U('B');
    L.pintar = t => {
      gl.viewport(0, 0, c.width, c.height);
      gl.uniform1f(uT, t); gl.uniform1f(uM, L.m); gl.uniform1f(uN, L.n); gl.uniform1f(uE, L.e); gl.uniform1f(uB, L.b);
      gl.drawArrays(gl.TRIANGLE_STRIP, 0, 4);
    };
    return L;
  };
  NHF.fx = fx;

  /* ======================================================================
     ARRANQUE de cada sección [data-nhf]
     ====================================================================== */
  function producto() {
    const s = document.querySelector('[data-nhx-producto]');
    let P = null; try { P = s ? JSON.parse(s.textContent) : null; } catch (e) { P = null; }
    return P || { fotos: [], variantes: [], opciones: [] };
  }

  function iniciar(sec) {
    if (sec.dataset.nhfListo) return;
    const handle = sec.dataset.nhfHandle;
    const fn = escenas[handle];
    if (!fn) return;
    sec.dataset.nhfListo = '1';
    const raiz = sec.querySelector('[data-nhf-root]');
    const base = sec.dataset.nhfBase || '';
    const ver = sec.dataset.nhfVer || '';
    raiz.innerHTML = '';
    const grid = el('div', 'nhf-grid');
    const zonaEscena = el('div', 'nhf-col-escena');
    const panel = el('div', 'nhf-panel');
    const pasosEl = el('ol', 'nhf-pasos');
    const ctrls = el('div', 'nhf-ctrls');
    const nota = el('p', 'nhf-nota'); nota.hidden = true;
    panel.append(pasosEl, ctrls, nota);
    grid.append(zonaEscena, panel); raiz.appendChild(grid);
    const visibles = new Set(); let enPantalla = false;
    const loops = new Set();
    const E = {
      sec, raiz, panel, ctrls, zonaEscena, handle, reduce, fino, esc, el, clamp, lerp, suave, salida, resorte, animar, animarP, esperar,
      precargar, vibrar, homografia, matriz3d, lerpQuad, quadEn, fx, sonido: Sonido, icono: svg, producto: producto(),
      archivo(n) { if (!n) return ''; if (/^(https?:)?\/\//.test(n) || /^(data|blob):/.test(n)) return n; return base + n + (ver ? '?v=' + ver : ''); },
      cargar(lista) { return Promise.all(lista.map(n => precargar(E.archivo(n)))); },
      lienzo(o) { const S = crearLienzo(E, o); E.S = S; return S; },
      titulo(t, lead) {
        const h = sec.querySelector('[data-nhf-titulo]'), l = sec.querySelector('[data-nhf-lead]');
        if (t && h) h.innerHTML = esc(t).replace(/\[(.+?)\]/g, '<em>$1</em>');
        if (lead != null && l) { l.textContent = lead; l.hidden = !lead; }
      },
      noche(si) { sec.classList.toggle('nhf--noche', !!si); },
      /* pasos numerados del panel: E.pasos(['Marca tu clave', 'Gira la perilla', ...]) y E.paso(i) marca el actual */
      pasos(lista) {
        pasosEl.innerHTML = lista.map((t, i) => '<li data-i="' + i + '"><b>' + String(i + 1).padStart(2, '0') + '</b><span>' + esc(t) + '</span></li>').join('');
      },
      paso(i, texto) {
        pasosEl.querySelectorAll('li').forEach(li => {
          const n = +li.dataset.i;
          li.classList.toggle('is-hecho', n < i); li.classList.toggle('is-actual', n === i);
          if (n === i && texto) li.querySelector('span').textContent = texto;
        });
      },
      nota(t) { nota.hidden = !t; nota.textContent = t || ''; },
      /* controles (van en el panel, o en "en" si se pasa) */
      seg(opciones, alElegir, op) {
        op = op || {};
        const g = el('div', 'nhf-seg', null, { role: 'group', 'aria-label': op.etiqueta || '' });
        opciones.forEach((o, i) => {
          const b = el('button', null, (o.color ? '<i style="background:' + esc(o.color) + '"></i>' : '') + esc(o.texto || o), { type: 'button', 'aria-pressed': String(i === (op.valor || 0)), 'data-v': o.id != null ? o.id : i });
          b.addEventListener('click', () => { g.querySelectorAll('button').forEach(x => x.setAttribute('aria-pressed', String(x === b))); vibrar(8); alElegir(o.id != null ? o.id : i, b); });
          g.appendChild(b);
        });
        g.elegir = v => g.querySelectorAll('button').forEach(x => x.setAttribute('aria-pressed', String(x.dataset.v === String(v))));
        (op.en || ctrls).appendChild(g);
        return g;
      },
      boton(texto, alTocar, op) {
        op = op || {};
        const b = el('button', 'nhf-btn' + (op.primario ? ' is-primario' : '') + (op.clase ? ' ' + op.clase : ''), (op.icono ? svg(op.icono, 17) : '') + '<span>' + esc(texto) + '</span>', { type: 'button' });
        b.addEventListener('click', e => { vibrar(8); alTocar(e, b); });
        b.texto = t => { b.querySelector('span').textContent = t; };
        (op.en || ctrls).appendChild(b);
        return b;
      },
      interruptor(texto, alCambiar, op) {
        op = op || {};
        const b = el('button', 'nhf-sw', '<span class="nhf-sw__k"></span><span class="nhf-sw__t">' + esc(texto) + '</span>', { type: 'button', role: 'switch', 'aria-checked': 'false' });
        let v = false;
        b.poner = (x, silencio) => { v = !!x; b.setAttribute('aria-checked', String(v)); if (!silencio) alCambiar(v); };
        b.addEventListener('click', () => { vibrar(10); b.poner(!v); });
        b.valor = () => v;
        (op.en || ctrls).appendChild(b);
        return b;
      },
      deslizador(op, alMover) {
        const w = el('label', 'nhf-rango', '<span class="nhf-rango__t">' + esc(op.etiqueta || '') + '</span><output class="nhf-rango__v"></output>');
        const r = el('input', 'nhf-range', null, { type: 'range', min: op.min || 0, max: op.max == null ? 100 : op.max, step: op.paso || 1, value: op.valor == null ? 0 : op.valor, 'aria-label': op.etiqueta || '' });
        const out = w.querySelector('output');
        const pintar = () => { const k = (r.value - r.min) / (r.max - r.min) * 100; r.style.setProperty('--k', k + '%'); out.textContent = op.formato ? op.formato(+r.value) : r.value; };
        r.addEventListener('input', () => { pintar(); alMover(+r.value); });
        w.appendChild(r); (op.en || ctrls).appendChild(w); pintar();
        w.input = r; w.poner = v => { r.value = v; pintar(); };
        return w;
      },
      lectura(op) {
        op = op || {};
        const d = el('div', 'nhf-lectura', '<span class="nhf-lectura__t">' + esc(op.etiqueta || '') + '</span><b class="nhf-lectura__v"></b>');
        const v = d.querySelector('b');
        d.poner = (t, peq) => { v.innerHTML = esc(t) + (peq ? '<small>' + esc(peq) + '</small>' : ''); };
        d.etiqueta = t => { d.querySelector('.nhf-lectura__t').textContent = t; };
        (op.en || ctrls).appendChild(d);
        return d;
      },
      /* perilla real: una capa de la foto (la perilla recortada) que se gira arrastrando alrededor de su centro.
         op: { centro:[x,y] (lienzo), radio, min, max, valor, grados:[g0,g1] (giro de min a max), pasos, etiqueta, formato,
         alCambiar, alSoltar, alTocar, elipse:[giro_eje_mayor_grados, menor/mayor] si la perilla se ve de lado } */
      perilla(capa, op) {
        const S = E.S, [cx, cy] = op.centro, g0 = op.grados[0], g1 = op.grados[1];
        let v = op.valor == null ? op.min : op.valor;
        const t = S.toque([cx - op.radio, cy - op.radio, op.radio * 2, op.radio * 2], { redonda: true, etiqueta: op.etiqueta, clase: 'nhf-perilla' });
        t.setAttribute('role', 'slider'); t.setAttribute('aria-valuemin', op.min); t.setAttribute('aria-valuemax', op.max);
        t.style.touchAction = 'none';
        const P = {
          el: t,
          valor: () => v,
          poner(x, silencio, dur) {
            const nv = clamp(op.pasos ? Math.round(x / op.pasos) * op.pasos : x, op.min, op.max);
            const cambio = nv !== v; v = nv;
            const g = lerp(g0, g1, (v - op.min) / (op.max - op.min || 1));
            capa.style.transition = dur ? 'transform ' + dur + 'ms cubic-bezier(.2,.7,.2,1)' : '';
            // perilla vista de lado (elipse): se endereza, se gira y se vuelve a inclinar
            capa.style.transform = op.elipse ? 'rotate(' + op.elipse[0] + 'deg) scale(1,' + op.elipse[1] + ') rotate(' + g.toFixed(2) + 'deg) scale(1,' + (1 / op.elipse[1]).toFixed(5) + ') rotate(' + (-op.elipse[0]) + 'deg)' : 'rotate(' + g.toFixed(2) + 'deg)';
            t.setAttribute('aria-valuenow', v); t.setAttribute('aria-valuetext', op.formato ? op.formato(v) : v);
            if (cambio && !silencio) { if (op.pasos) { Sonido.clic(); vibrar(6); } if (op.alCambiar) op.alCambiar(v); }
          }
        };
        let a0 = 0, v0 = 0;
        const ang = e => { const r = capa.getBoundingClientRect(); const p = S.punto(e); return Math.atan2(p.y - cy, p.x - cx) * 180 / Math.PI; };
        t.addEventListener('pointerdown', e => { try { t.setPointerCapture(e.pointerId); } catch (x) {} a0 = ang(e); v0 = v; t.classList.add('is-activa'); S.el.classList.add('is-tocado'); if (op.alEmpezar) op.alEmpezar(); });
        t.addEventListener('pointermove', e => {
          if (!t.classList.contains('is-activa')) return;
          let d = ang(e) - a0; if (d > 180) d -= 360; if (d < -180) d += 360;
          const porGrado = (op.max - op.min) / (g1 - g0);
          P.poner(v0 + d * porGrado);
          if (Math.abs(d) > 120) { a0 = ang(e); v0 = v; }
        });
        const fin = () => { if (!t.classList.contains('is-activa')) return; t.classList.remove('is-activa'); if (op.alSoltar) op.alSoltar(v); };
        t.addEventListener('pointerup', fin); t.addEventListener('pointercancel', fin);
        t.addEventListener('keydown', e => {
          const s = op.pasos || (op.max - op.min) / 20;
          if (e.key === 'ArrowRight' || e.key === 'ArrowUp') { e.preventDefault(); P.poner(v + s); if (op.alSoltar) op.alSoltar(v); }
          if (e.key === 'ArrowLeft' || e.key === 'ArrowDown') { e.preventDefault(); P.poner(v - s); if (op.alSoltar) op.alSoltar(v); }
        });
        t.addEventListener('click', e => { if (op.alTocar) op.alTocar(e); });
        P.poner(v, true);
        return P;
      },
      /* control o panel REAL (control remoto, botonera, pantalla táctil): la foto del control con sus botones reales
         tocables; cada botón se hunde con su propio pedazo de foto. op: { src, w, h (px de la imagen), botones:
         { id: [x, y] (centro, px de la imagen) }, r (radio del botón, px), etiquetas: { id: 'texto' }, alTocar(id),
         ancho (css, p. ej. '210px' o '58%'), en } */
      control(op) {
        const c = el('div', 'nhf-mando' + (op.clase ? ' ' + op.clase : ''));
        c.style.aspectRatio = op.w + ' / ' + op.h;
        if (op.ancho) c.style.width = op.ancho;
        const url = E.archivo(op.src);
        c.innerHTML = '<img class="nhf-mando__img" src="' + esc(url) + '" alt="' + esc(op.alt || 'Control remoto') + '" draggable="false">';
        const R = op.r || 30, bots = {};
        Object.keys(op.botones).forEach(id => {
          const [x, y] = op.botones[id], rr = (op.radios && op.radios[id]) || R;
          const b = el('button', 'nhf-mando__b', null, { type: 'button', 'aria-label': (op.etiquetas && op.etiquetas[id]) || id, 'data-b': id });
          b.style.left = ((x - rr) / op.w * 100) + '%'; b.style.top = ((y - rr) / op.h * 100) + '%';
          b.style.width = (rr * 2 / op.w * 100) + '%'; b.style.height = (rr * 2 / op.h * 100) + '%';
          b.style.backgroundImage = 'url("' + url + '")';
          b.style.backgroundSize = (op.w / (rr * 2) * 100) + '% ' + (op.h / (rr * 2) * 100) + '%';
          b.style.backgroundPosition = ((x - rr) / (op.w - rr * 2) * 100) + '% ' + ((y - rr) / (op.h - rr * 2) * 100) + '%';
          b.addEventListener('click', e => {
            e.preventDefault(); b.classList.remove('is-hunde'); void b.offsetWidth; b.classList.add('is-hunde');
            vibrar(8); Sonido.clic(); if (E.S) E.S.el.classList.add('is-tocado'); if (op.alTocar) op.alTocar(id, b);
          });
          c.appendChild(b); bots[id] = b;
        });
        c.botones = bots;
        c.pista = lista => Object.keys(bots).forEach(id => bots[id].classList.toggle('is-pista', (lista || []).indexOf(id) >= 0));
        (op.en || ctrls).appendChild(c);
        return c;
      },
      /* arrastrar una capa real (plato, llave, tapa) dentro del lienzo, con imanes a sus lugares reales.
         op: { destinos:[{x,y,r,id}], limites:[x0,y0,x1,y1], eje:'x'|'y'|null, alMover(p), alSoltar(destino|null,p), etiqueta } */
      arrastrable(capa, op) {
        const S = E.S; op = op || {};
        const b = capa._caja; let dx = 0, dy = 0, ini = null, activo = false;
        capa.classList.add('nhf-arrastrable'); capa.style.touchAction = 'none'; capa.style.pointerEvents = 'auto';
        capa.setAttribute('tabindex', '0'); capa.setAttribute('role', 'button'); if (op.etiqueta) capa.setAttribute('aria-label', op.etiqueta);
        const A = {
          pos: () => ({ x: b[0] + dx, y: b[1] + dy, dx, dy }),
          mover(x, y, dur) {
            dx = op.eje === 'y' ? 0 : x; dy = op.eje === 'x' ? 0 : y;
            if (op.limites) { const L = op.limites; dx = clamp(dx, L[0] - b[0], L[2] - b[0] - b[2]); dy = clamp(dy, L[1] - b[1], L[3] - b[1] - b[3]); }
            capa.style.transition = dur ? 'transform ' + dur + 'ms cubic-bezier(.2,.8,.2,1)' : 'none';
            capa.style.transform = 'translate3d(' + dx + 'px,' + dy + 'px,0)' + (op.extra ? ' ' + op.extra(A.pos()) : '');
          },
          activo: () => activo
        };
        capa.addEventListener('pointerdown', e => {
          if (e.button > 0) return; activo = true; S.el.classList.add('is-tocado');
          try { capa.setPointerCapture(e.pointerId); } catch (x) {}
          const p = S.punto(e); ini = { x: p.x - dx, y: p.y - dy }; capa.classList.add('is-arrastrando'); if (op.alEmpezar) op.alEmpezar();
        });
        capa.addEventListener('pointermove', e => { if (!activo) return; const p = S.punto(e); A.mover(p.x - ini.x, p.y - ini.y); if (op.alMover) op.alMover(A.pos()); });
        const fin = () => {
          if (!activo) return; activo = false; capa.classList.remove('is-arrastrando');
          const p = A.pos(), c = { x: p.x + b[2] / 2, y: p.y + b[3] / 2 };
          let d = null; (op.destinos || []).forEach(t => { if (Math.hypot(c.x - t.x, c.y - t.y) <= t.r && !d) d = t; });
          if (op.alSoltar) op.alSoltar(d, p);
        };
        capa.addEventListener('pointerup', fin); capa.addEventListener('pointercancel', fin);
        capa.addEventListener('keydown', e => { if ((e.key === 'Enter' || e.key === ' ') && op.alTeclado) { e.preventDefault(); op.alTeclado(); } });
        return A;
      },
      /* bucle de dibujo que solo corre cuando la escena se ve en pantalla */
      bucle(fn) {
        const L = { vivo: true, t0: 0, ult: 0 };
        const paso = t => {
          if (!L.vivo) return;
          if (enPantalla && !document.hidden) { const dt = L.ult ? Math.min(0.05, (t - L.ult) / 1000) : 0.016; L.ult = t; fn(t / 1000, dt); } else L.ult = 0;
          requestAnimationFrame(paso);
        };
        L.parar = () => { L.vivo = false; loops.delete(L); };
        loops.add(L); requestAnimationFrame(paso);
        return L;
      },
      enPantalla: () => enPantalla,
      alVer(cb, umbral) {
        if (!('IntersectionObserver' in window)) { cb(); return; }
        const ob = new IntersectionObserver(es => es.forEach(en => { if (en.isIntersecting) { ob.disconnect(); cb(); } }), { threshold: umbral == null ? 0.45 : umbral });
        ob.observe(E.S ? E.S.el : raiz);
      },
      /* botón de sonido en la escena (apagado por defecto; la clienta lo prende) */
      conSonido() {
        const S = E.S; if (!S) return;
        const b = el('button', 'nhf-hud-btn nhf-sonido', svg('mudo', 18), { type: 'button', 'aria-label': 'Activar sonido', 'aria-pressed': 'false' });
        b.addEventListener('click', e => { e.stopPropagation(); Sonido.activo = !Sonido.activo; b.setAttribute('aria-pressed', String(Sonido.activo)); b.setAttribute('aria-label', Sonido.activo ? 'Silenciar' : 'Activar sonido'); b.innerHTML = svg(Sonido.activo ? 'sonido' : 'mudo', 18); if (Sonido.activo) Sonido.bip(1500); });
        S.hud.appendChild(b);
      },
      /* fin del recorrido: resalta "Pídelo y paga al recibir" y deja el botón "Ver de nuevo" */
      listo(texto, repetir) {
        sec.classList.add('nhf--listo');
        if (texto) E.nota(texto);
        if (repetir && !E._rep) {
          const S = E.S;
          const b = el('button', 'nhf-hud-btn nhf-repetir', svg('repetir', 18) + '<span>Ver de nuevo</span>', { type: 'button' });
          b.addEventListener('click', e => { e.stopPropagation(); sec.classList.remove('nhf--listo'); repetir(); });
          (S ? S.hud : raiz).appendChild(b); E._rep = b;
        }
      },
      noListo() { sec.classList.remove('nhf--listo'); },
      /* variantes: escuchar la elegida arriba y elegir desde la escena (sincroniza con la compra) */
      alCambiarVariante(cb) { document.addEventListener('nt:variant', e => { if (e.detail && e.detail.variant) cb(e.detail.variant, e.detail); }); },
      seleccionar(indice, valor) { document.dispatchEvent(new CustomEvent('nt:select', { detail: { index: indice, value: valor } })); },
      varianteActual() {
        const inp = document.querySelector('[data-variant-id]'); const id = inp ? +inp.value : 0;
        return (E.producto.variantes || []).find(v => v.id === id) || (E.producto.variantes || [])[0] || null;
      }
    };
    // pausar los bucles cuando la escena no se ve
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(es => es.forEach(en => { enPantalla = en.isIntersecting; sec.classList.toggle('nhf--en-pantalla', enPantalla); }), { threshold: 0.05 }).observe(sec);
      // en el celular el botón flotante de WhatsApp tapa los controles de la derecha: se esconde mientras la clienta
      // usa la escena (escenario o controles en pantalla) y vuelve al salir
      const io = new IntersectionObserver(es => es.forEach(en => { visibles[en.isIntersecting ? 'add' : 'delete'](en.target); document.documentElement.classList.toggle('nhf-sin-wa', visibles.size > 0); }), { rootMargin: '-15% 0px -15% 0px' });
      io.observe(grid);
    } else enPantalla = true;
    try {
      const r = fn(E);
      if (r && r.catch) r.catch(err => fallar(sec, handle, err));
      sec.classList.add('nhf--listo-js');
    } catch (err) { fallar(sec, handle, err); }
  }
  function fallar(sec, handle, err) {
    if (window.console) console.error('[nhf] ' + handle, err);
    sec.hidden = true;
  }

  NHF.escena = function (handle, fn) {
    escenas[handle] = fn;
    if (domListo) document.querySelectorAll('[data-nhf][data-nhf-handle="' + handle + '"]:not([data-nhf-listo])').forEach(iniciar);
  };
  let domListo = document.readyState !== 'loading';
  function todo() {
    domListo = true;
    document.querySelectorAll('[data-nhf]').forEach(s => {
      iniciar(s);
      // si la escena no llegó (archivo que falta o error de red), la sección no se queda vacía: se oculta
      setTimeout(() => { if (!s.dataset.nhfListo) { if (window.console) console.warn('[nhf] sin escena: ' + s.dataset.nhfHandle); s.hidden = true; } }, 6000);
    });
  }
  if (domListo) setTimeout(todo, 0); else document.addEventListener('DOMContentLoaded', todo);
  document.addEventListener('shopify:section:load', e => { const s = e.target.querySelector('[data-nhf]'); if (s) iniciar(s); });
})();
